(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/intersection-observer/assets/javascripts/react-intersection-provider.js') >= 0) return;  svs.modules.push('/components/lb-utils/intersection-observer/assets/javascripts/react-intersection-provider.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  useMemo,
  useCallback,
  useRef,
  useEffect
} = React;
const {
  ReactIntersectionContext
} = svs.components.lbUtils.intersectionObserver;
const createObserverKey = opt => {
  const rootId = opt.root ? opt.root.toString() : 'window';
  const threshold = opt.threshold.map(t => "".concat(t)).join();
  return (rootId + opt.rootMargin + threshold).replace(/\s+/i, '');
};
const createObservedEl = (el, cb, opt) => ({
  el,
  observed: false,
  cb,
  opt,
  observerKey: createObserverKey(opt)
});
const ReactIntersectionProvider = _ref => {
  let {
    children
  } = _ref;
  const observedList = useRef({});
  const observer = useRef({});
  const connectElement = useCallback((el, cb, option) => {
    if (el && !observedList.current[el]) {
      const defaultOpt = {
        root: null,
        rootMargin: '0px',
        threshold: [0.0]
      };
      const observerOpt = _objectSpread(_objectSpread({}, defaultOpt), option);
      observedList.current[el] = createObservedEl(el, cb, observerOpt);
    }
  }, []);
  const disconnectElement = useCallback(el => {
    if (el && observedList.current[el] && observer.current && Object.keys(observer.current) > 0) {
      const observerKey = observedList.current[el].observerKey;
      delete observedList.current[el];
      const observered = Object.values(observedList.current);
      if (observered.length === 0) {
        const keys = Object.keys(observer.current);
        keys.forEach(k => {
          observer.current[k].disconnect();
          observer.current[k] = null;
        });
      } else if (!observered.find(el => el.observerKey === observerKey)) {
        observer.current[observerKey].disconnect();
        observer.current[observerKey] = null;
      }
    }
  }, []);
  const changeElementCallback = useCallback((el, cb) => {
    if (el && observedList.current[el] && cb) {
      observedList.current[el] = _objectSpread(_objectSpread({}, observedList.current[el]), {}, {
        cb
      });
    }
  }, []);
  const observeElement = useCallback(el => {
    if (el && observedList.current[el] && observer.current) {
      observedList.current[el] = _objectSpread(_objectSpread({}, observedList.current[el]), {}, {
        observed: true
      });
      if (!observer.current[observedList.current[el].observerKey]) {
        observer.current[observedList.current[el].observerKey] = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (observedList.current[entry.target] && observedList.current[entry.target].observed && observedList.current[entry.target].cb) {
              observedList.current[entry.target].cb(entry);
            }
          });
        }, observedList.current[el].opt);
      }
      observer.current[observedList.current[el].observerKey].observe(el);
    }
  }, []);
  const unobserveElement = useCallback(el => {
    if (el && observedList.current[el] && observer.current) {
      observedList.current[el] = _objectSpread(_objectSpread({}, observedList.current[el]), {}, {
        observed: false
      });
      observer.current[observedList.current[el].observerKey].unobserve(el);
    }
  }, []);
  useEffect(() => () => {
    if (observer.current) {
      const keys = Object.keys(observer.current);
      keys.forEach(k => {
        observer.current[k].disconnect();
      });
      observer.current = null;
    }
  }, []);
  const context = useMemo(() => ({
    observeElement,
    unobserveElement,
    disconnectElement,
    connectElement,
    changeElementCallback
  }), [connectElement, disconnectElement, observeElement, unobserveElement, changeElementCallback]);
  return React.createElement(ReactIntersectionContext.Provider, {
    value: context
  }, children);
};
setGlobal('svs.components.lbUtils.intersectionObserver.ReactIntersectionProvider', ReactIntersectionProvider);

 })(window);